var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Modal from 'react-modal';
import InviteAdminModalBody from './InviteAdminModalBody';
var InviteAdminModal = function (_a) {
    var isVisible = _a.isVisible, setIsVisible = _a.setIsVisible;
    return (_jsx(Modal, __assign({ headerTitle: "New Version", open: isVisible, onClose: function () {
            setIsVisible(false);
        }, isOpen: isVisible, onRequestClose: function () {
            setIsVisible(false);
        }, style: {
            content: {
                width: '500px',
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                boxShadow: '2px 2px 16px rgba(0, 0, 0, 0.2)',
                borderRadius: '8px',
                padding: '0',
                border: '0',
                maxHeight: '100vh',
            },
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.25)',
            },
        }, contentLabel: "Media" }, { children: _jsx(InviteAdminModalBody, { setIsVisible: setIsVisible }) })));
};
export default InviteAdminModal;
